import { IconCircleInfo } from "@central-icons-react/round-filled-radius-2-stroke-2/IconCircleInfo";
import { IconExclamationTriangle } from "@central-icons-react/round-filled-radius-2-stroke-2/IconExclamationTriangle";
import clsx from "clsx";

const icons = {
  IconCircleInfo,
  IconExclamationTriangle,
} as const;

const variants = {
  info: "bg-blue/5 border-blue/10 text-blue-dark",
  error: "bg-red/5 border-red/10 text-red",
};

export function Message({
  children,
  iconName,
  className,
  variant = "info",
}: {
  children: React.ReactNode;
  iconName: keyof typeof icons;
  className?: string;
  variant?: keyof typeof variants;
}) {
  const Icon = icons[iconName];
  return (
    <div
      className={clsx(
        "border rounded-md p-2 flex items-center gap-2 text-sm mt-4",
        variants[variant],
        className,
      )}
    >
      <Icon className="shrink-0" />
      <span>{children}</span>
    </div>
  );
}
